import { Auth, getAuth, signInWithCustomToken, UserCredential } from 'firebase/auth'

import { app } from './app'

let instance: Auth
const auth = (): Auth => (instance ||= getAuth(app()))
const authState: { signing: boolean; uid?: string } = {
  uid: undefined,
  signing: false,
}

interface InitialState {
  customToken: null
  promise: Promise<void>
}

interface State {
  customToken: string
  promise: Promise<UserCredential>
}

const signingState = {
  customToken: null,
  promise: Promise.resolve(),
} as InitialState | State

const signIn = (firebaseToken: string): Promise<UserCredential> => {
  authState.signing = true
  if (signingState.customToken != firebaseToken) {
    signingState.customToken = firebaseToken
    const safePromise = signingState.promise
      .catch(() => {}) // prevent chain break
      .then(() => signInWithCustomToken(auth(), firebaseToken))
    signingState.promise = safePromise
  }

  return (signingState as State).promise
    .then((credential) => {
      authState.uid = credential.user.uid
      return credential
    })
    .finally(() => {
      authState.signing = false
    })
}

export { signIn, authState }
